module.exports = __webpack_public_path__ + "static/media/sumo.1319b947.webp";